import React from 'react';
import { Modal } from 'react-bootstrap';
import { ImageTrafficCone } from '../../assets/images';
import { TranslationUtils, ValidationUtils } from '../../utils';
import './CancellationErrorModal.scss';

interface CancellationErrorModalProps {
    show: boolean;
    handleClose: () => void;
}

export const CancellationErrorModal: React.FC<CancellationErrorModalProps> = (props) => {
    const { show, handleClose } = props;
    let localPhoneNumber = ValidationUtils.validateAndGetEnvVar('REACT_APP_TOLL_FREE_PHONE_NUMBER');
    const phone = <a href={`tel:${localPhoneNumber}`}>{localPhoneNumber}</a>;
    return (
        <Modal id="cancellation-error-modal" show={show} onHide={handleClose}>
            <Modal.Header closeButton />
            <div className="cancellation-error-body">
                <ImageTrafficCone className="cancellation-error-image" />
                <h4>{TranslationUtils.get('something_went_wrong')}.</h4>
                <p className="cancellation-error-instructions">
                    <span>{TranslationUtils.get('error_cancelling')}</span>{' '}
                    <span>{TranslationUtils.get('contact_customer_service', { phone })}</span>
                </p>
            </div>
        </Modal>
    );
};
